import { useEffect, useState, useMemo } from "react";
import { Badge, Box, Button, Heading, Text, Flex, useToast, Input, NumberInput,NumberInputField,NumberInputStepper,NumberIncrementStepper,NumberDecrementStepper, Spacer, useDisclosure, Modal, ModalOverlay, ModalCloseButton, ModalContent, ModalHeader, ModalBody, ModalFooter,} from "@chakra-ui/react";
import { MdArrowBack, MdDelete, MdOutlinePlayArrow, } from "react-icons/md";
import { PiArrowFatUpFill, PiArrowFatDownFill  } from "react-icons/pi";
import { react_api } from "../../config";
import { CASE_TYPE } from "../../CaseTypeCostant";
import { HTTP_STATUS_CODES } from "../../GrinsCostant";
import logout from "../../services/authService";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";
import { useTranslation } from "react-i18next";
import { useSession } from "../../SessionContext";
import { useNavigate, useLocation } from "react-router-dom";
import SpinnerXL from "../SpinnerXL";
import { MultiSelect } from "react-multi-select-component";
import { useBreakpointValue } from "@chakra-ui/react";

const getBackgroundColorByVisibility = (visibility) => {
    if (visibility === "private") {
        return "green.400";
    } else if (visibility === "obtained") {
        return "orange.400";
    } else if (visibility === "public") {
        return "yellow.400";
    } else if (visibility === "general") {
        return "blue.400";
    } else {
        return "blue.500";
    }
};
const DatasetItem = ({ id, text, visibility, onSelect, isSelected }) => {
    let buttonColor = isSelected ? "gray.400" : getBackgroundColorByVisibility(visibility);
    return (
        <Button
            h="20px"
            bg={buttonColor}
            borderWidth={1}
            borderColor={"black"}
            onClick={()=> onSelect(text)}
            isDisabled={isSelected} 
            maxW="100%" 
            overflow="hidden" 
            textOverflow="ellipsis" 
            whiteSpace="nowrap"
            display="inline-block"
        >
            {text}
        </Button>
    );
};

const CategoryBox = ({ id, name, color, items, onSelect, selectedDataset, t, searchTerm, onSearchChange, }) => {
    const filteredItems = items.filter((item) =>
        item.table_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
        <Box key={id} mt={4} p={3} borderRadius="md" borderWidth={2} borderColor={`${color}.500`}>
            <Heading fontSize="md" color={`${color}.600`} mb={2}>
                {name}
            </Heading>
            <Input
                bg={"white"}
                placeholder={`${t("core.datasetBox.searchDataset")}${name}`}
                value={searchTerm}
                onChange={(e) => onSearchChange(id, e.target.value)}
                mb={2}
            />
            {filteredItems.length > 0 ? (
                filteredItems.map(({ table_id, table_name, visibility }) => (
                    <DatasetItem
                        key={table_id}
                        id={{ id: table_name, type: "dataset" }}
                        text={table_name}
                        visibility={visibility}
                        onSelect={onSelect}
                        isSelected={selectedDataset === table_name}
                    />
                ))
            ) : (
                <Text color="gray.500">{t("core.datasetBox.noDatasetsAvailable")}</Text>
            )}  
        </Box>
    );
};

function CustomizedOverallRankingEngine () {
    const location = useLocation();
    const titleService = location.state?.title;
    const { t } = useTranslation();
    const toast = useToast();
    const navigate = useNavigate();
    const { updateSessionData, clearSessionData } = useSession();
    const axiosInstance = createAxiosInstance(async (axiosInstance) => {
        logout(t, clearSessionData, navigate, toast, axiosInstance);
    });
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [catalog, setCatalog] = useState([]);
    const [selectedDataset, setSelectedDataset] = useState(null);
    const [resultApp, setResultApp] = useState(false);
    const [searchTerms, setSearchTerms] = useState({});
    const categories = [
        { id: 1, name: "Catalog General", type: "catalogo_generale", color: "blue" },
        { id: 2, name: "Catalog Results", type: "catalogo_risultati", color: "green" },
        { id: 3, name: "Catalog Processing", type: "catalogo_elaborazioni", color: "orange" },
        { id: 4, name: "Catalog Staging", type: "catalogo_staging", color: "purple" },
    ];
    const [columns, setColumns] = useState([]);
    const [firstColumnName, setFirstColumnName] = useState("");
    const [preferenceDirection, setPreferenceDirection] = useState({});
    const [multiSelectOptions, setMultiSelectOptions] = useState([]);
    const [selectedAlternatives, setSelectedAlternatives] = useState([]);
    const [expressCards, setExpressCards] = useState([]);
    const perPage = 100;
    const [page, setPage] = useState(1);
    const [searchAlternative, setSearchAlternative] = useState("");
    const [htmlResult, setHtmlResult] = useState("");
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        const fetchCatalog = async () => {
            try {
                const richiesta = {
                    BearerToken: sessionStorage.getItem("token"),
                    username: sessionStorage.getItem("username"),
                    caseType: CASE_TYPE.CATALOG_ALL,
                };
                const options = {
                    headers: {
                        "Content-Type": "application/json",
                    }
                };
                const urlFetch = `${react_api}/DragAndDrop/getDatasetsADP`;
                const response = await axiosInstance.post(urlFetch, richiesta, options);
                const result = response.data;
                const tablesInfo = result?.tables_info;

                if ( result == null || (Object.keys(result).length === 0)) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t('messageBE.momentaryCommunicationError'), 
                        status: 'warning',
                        duration: 4000,
                        isClosable: true,
                        position: 'top'
                    });
                    return;  
                }

                if (!Array.isArray(tablesInfo) || tablesInfo.length === 0) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t('toastMsg.momentaryCommunicationError'),
                        status: 'warning',
                        duration: 4000,
                        isClosable: true,
                        position: 'top'
                    });
                    return;
                }
                if (result.status !== HTTP_STATUS_CODES.OK) {
                    toast({
                        title: t('toastMsg.error'),
                        description: t(`messageBE.${result.message}`),
                        position: "top",
                        status: 'error',
                        duration: 4000,
                        isClosable: true
                    });
                }
                if (result.status === HTTP_STATUS_CODES.OK) {
                    setCatalog(result.tables_info);
                }
            } catch (error) {
                toast({
                    title: t('toastMsg.callError'),
                    description: String(error),
                    position: "top",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
            }
        };
        fetchCatalog();
    }, [toast]);
    
    const fetchColumns = async (tableId) => {
        try {
            const urlFetch = `${react_api}/DragAndDrop/getDatasetColADP/${tableId}`;
            const response = await axiosInstance.get(urlFetch);
            const result = response?.data;

            if ( result == null || (Object.keys(result).length === 0)) {
                toast({
                    title: t('toastMsg.error'),
                    description: t('messageBE.momentaryCommunicationError'), 
                    status: 'warning',
                    duration: 4000,
                    isClosable: true,
                    position: 'top'
                });
                return;  
            }

            return result;

        } catch (error) {
            toast({
            title: t('toastMsg.callError'),
            description: String(error),
            position: "top",
            status: "warning",
            duration: 4000,
            isClosable: true,
            });
        }
    };

    const fetchValuesFirstColumn = async (datasetName, columnName) => {
        try {
            setSpinnerLoading(true);
            const request = {
                BearerToken: sessionStorage.getItem("token"),
                username: sessionStorage.getItem("username"),
                tableName: datasetName,
                columnName: columnName,
            };
            const urlFetch = `${react_api}/externalService/getColumn`;
            const response = await axiosInstance.post(urlFetch, request);
            const result = response?.data;

            if ( result == null || (Object.keys(result).length === 0)) {
                toast({
                    title: t('toastMsg.error'),
                    description: t('messageBE.momentaryCommunicationError'), 
                    status: 'warning',
                    duration: 4000,
                    isClosable: true,
                    position: 'top'
                });
                return;  
            }
            if (result.status !== HTTP_STATUS_CODES.OK) {
                toast({
                    title: t('toastMsg.error'),
                    description: t(`messageBE.${result.message}`),
                    position: "top",
                    status: 'error',
                    duration: 4000,
                    isClosable: true
                });
                return;
            }
            if (result.status === HTTP_STATUS_CODES.OK) {
                const options = result.data.map((val, idx) => ({
                    label: val,
                    value: val,
                    index: idx
                }));
                setMultiSelectOptions(options);
            }
        } catch (error) {
            toast({
                title: t('toastMsg.callError'),
                description: String(error),
                position: "top",
                status: "warning",
                duration: 4000,
                isClosable: true,
            });
        }finally{
            setSpinnerLoading(false);
        }
    };

    // Sezione Preference direction 
    useEffect(() => {
        if(columns.length) {
            const prefObj = {};
            columns.forEach(col => {
                if(col.index !== "0") {
                    prefObj[col.columnName] = true; 
                }
            });
            setPreferenceDirection(prefObj);
        }
    }, [columns]);
    
    const handleDirectionChange = (columnName, direction) => {
        setPreferenceDirection(prev => ({
        ...prev,
        [columnName]: direction
        }));
    };

    // Sezione Alternative 
    
    useEffect(() => {
        setPage(1);
    }, [searchAlternative]);
        
    const filtered = useMemo(
        () => multiSelectOptions.filter(opt =>
            opt.label.toLowerCase().includes(searchAlternative.toLowerCase())
        ),
        [multiSelectOptions, searchAlternative]
    );

    const baseOptions = useMemo(
      () => filtered.slice(0, page * perPage),
        [filtered, page]
    );

    const hasMore = page * perPage < filtered.length;

    // se ci sono ancora elementi, aggiunge il sentinel
    const displayOptions = useMemo(
        () =>
            hasMore
            ? [...baseOptions, { label: <Text color="rgba(11,78,90,255)" fontWeight="bold">{t('core.operationsBox.loadMoreAlternatives')}</Text>, value: "__load_more__" }]
            : baseOptions,
        [baseOptions, hasMore]
    );

    const handleChange = (items) => {
        if (items.some(i => i.value === "__load_more__")) {
            setPage(p => p + 1);
            setSelectedAlternatives(prev => prev.filter(i => i.value !== "__load_more__"));
        } else {
            setExpressCards([]);
            setSelectedAlternatives(items);
        }
    };

    const resetAlternatives = () => {
        setSelectedAlternatives([]);
        setExpressCards([]);
    };

    const submitAlternatives = () => {
        getSelectedArrays();
        const cards = selectedAlternatives.map(item => ({
            label: item.label,
            e_L: "0",
            E_U: "1000000"
        }));
        setExpressCards(cards);
    };

    const getSelectedArrays = () => {
        const valuesArray = selectedAlternatives.map(item => item.value);
        const indicesArray = selectedAlternatives.map(item => item.index);
        return { valuesArray, indicesArray };
    };

    // Sezione Express Cards 
    const updateExpressCard = (index, updatedFields) => {
        setExpressCards(prev => {
            const updatedCards = [...prev];
            updatedCards[index] = { ...updatedCards[index], ...updatedFields };
            return updatedCards;
        });
    };

    const handleCardChange = (index, field) => (valueString) => {
        if (/^$|^(0|[1-9][0-9]*)$/.test(valueString)) {
        updateExpressCard(index, { [field]: valueString });
        }
    };

    const isCardValid = (card) => {
        if (card.e_L === "" || card.E_U === "") return false;
        return Number(card.e_L) <= Number(card.E_U);
    };

    const sendData = async () => {
        try {
            setSpinnerLoading(true);
            const payload = {
                BearerToken: sessionStorage.getItem("token"),
                username: sessionStorage.getItem("username"),
                service_name: "ceci",
                dataset: selectedDataset, 
                first_column: firstColumnName, 
                preference_direction : preferenceDirection,
                alternative : {
                    values: selectedAlternatives.map(item => item.label),
                    indices: selectedAlternatives.map(item => item.index)
                },
                express_cards : expressCards.reduce((acc, card) => {
                    acc[card.label] = { e_L: card.e_L, E_U: card.E_U };
                    return acc;
                }, {}),
            };
            console.log(JSON.stringify(payload))
            const urlFetch = `${react_api}/linkInternalServicesHTMLReceivedADP`;
            const response = await axiosInstance.post(urlFetch, payload);
            const result = response?.data;

            if ( result == null || (Object.keys(result).length === 0)) {
                toast({
                    title: t('toastMsg.error'),
                    description: t('messageBE.momentaryCommunicationError'), 
                    status: 'warning',
                    duration: 4000,
                    isClosable: true,
                    position: 'top'
                });
                return;  
            }
            if (result.status == undefined) {
                setSpinnerLoading(false);
                toast({
                    title: t("toastMsg.error"),
                    description: "Invalid token",
                    position: "top",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
                return;
            }
            if (result.status !== HTTP_STATUS_CODES.OK) {
                setSpinnerLoading(false);
                toast({
                title: t("toastMsg.error"),
                description: t(`messageBE.${result.message}`),
                position: "top",
                status: "error",
                duration: 4000,
                isClosable: true,
                });
            }
            if (result.status === HTTP_STATUS_CODES.OK) {
                setSpinnerLoading(false);
                toast({
                    title:  t(`toastMsg.core.coreSuccessful`),
                    // description: t(`messageBE.${result.message}`),
                    position: "top",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
                setHtmlResult(result.htmlPage);
                setResultApp(true);
            }
        } catch (error) {
            setSpinnerLoading(false);
            toast({
                title: t("toastMsg.callError"),
                description: String(error.message),
                position: "top",
                status: "warning",
                duration: 4000,
                isClosable: true,
            });
        }
    };

    const handleSearchChange = (categoryId, value) => {
        setSearchTerms((prev) => ({ ...prev, [categoryId]: value }));
    };

    const handleDatasetSelect = (dataset) => {
        clearAllData();
        setSelectedDataset(dataset);
        const selectedTable = catalog.find((item) => item.table_name === dataset);
        if (selectedTable) {
            fetchColumns(selectedTable.table_id).then((columnRes) => {
                if (columnRes && columnRes.tableInfo) {
                    const sortedColumns = columnRes.tableInfo.sort((a, b) => a.index - b.index);
                    const columnsRemoved = ['metadata_vd', 'metadata_vtd', 'metadata_ud'];
                    const filteredColumns = sortedColumns.filter(
                        (col) => !columnsRemoved.includes(col.columnName)
                    );
                    setColumns(filteredColumns);
                    const firstColumn = filteredColumns.find((col) => col.index === "0");
                    if (firstColumn) {
                        setFirstColumnName(firstColumn.columnName);
                        fetchValuesFirstColumn(dataset, firstColumn.columnName);
                    }
                }
            });
        }
    };

    const handleConfirm = () => {
        clearAllData();
        clearResult();
        onClose();
    };
    
    const clearAllData = () => {
        setSelectedDataset(null);
        setColumns([]);
        setFirstColumnName("");
        setPreferenceDirection({});
        setSearchAlternative("");
        setSelectedAlternatives([]);
        setExpressCards([]);
    };

    const clearResult = () =>{
        setResultApp(false);
        setHtmlResult("");
    };

    useEffect(() => {
        if (isStartDisabled()) {
            clearResult();
        }
    }, [
        selectedDataset, 
        columns, 
        firstColumnName, 
        preferenceDirection,
        searchAlternative,
        selectedAlternatives,
        expressCards
    ]);

    const isStartDisabled = () => {
        return expressCards.length > 0 && expressCards.every(isCardValid);
    };   

    const datasetHeight = useBreakpointValue({
        base: "auto",
        md: "80vh",
        lg: "calc(100vh - 70px)" 
    });
    
    return (
        <Box position="relative" minHeight="100vh" width="100%" p={2} bg="#f6f3ec">
            {spinnerLoading && <SpinnerXL />}
            <Flex Flex mb={2} align="center" gap={2} pr={3}>
                <Heading color="rgba(11,78,90,255)">{titleService}</Heading>
                <Spacer />
                {!resultApp && (
                    <>
                        <Button size="sm" variant="outline" colorScheme="red" _hover={{bg: "red.500", color: "white",}} onClick={() => onOpen()}>
                            {t('core.btnClearData')} <MdDelete size={18} />
                        </Button>
                        <Button size="sm" variant="outline" _hover={{bg: "green.500", color: "white",}} colorScheme="green" onClick={sendData} isDisabled={!isStartDisabled()}>
                            {t('core.btnStart')} <MdOutlinePlayArrow size={18} />
                        </Button>
                    </>
                )}
                {resultApp && (
                    <Button p={3} gap={2} size="sm" variant="outline" _hover={{bg: "teal.500", color: "white",}}  colorScheme="teal" onClick={() => setResultApp(false)}>
                        <MdArrowBack size={18} />
                        {t('core.btnBack')}
                    </Button>
                )}
            </Flex>         
            <Flex direction={{ base: "column", md: "row" }} gap={2} align="flex-start" overflowX="auto">
                {!resultApp && (
                    <>
                        <Box borderWidth={2} overflowY="auto" borderColor="rgba(23, 141, 161, 1)" borderRadius={5} height={datasetHeight} width={{ base: "100%", md: "30%" }} p={3}>
                            <Box justifyContent="space-between">
                                <Heading fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">Dataset</Heading>
                                <Box w="100%" justifyContent="space-between">
                                    {t('core.datasetBox.legend')}:
                                    <Badge ml={2} colorScheme="green" variant="solid">Private</Badge>
                                    <Badge ml={2} colorScheme="yellow" variant="solid">Public</Badge>
                                    <Badge ml={2} colorScheme="orange" variant="solid">Obtained</Badge>
                                    <Badge ml={2} colorScheme="blue" variant="solid">General</Badge>
                                </Box>
                            </Box>
                            <Box justifyContent="space-between" mt="1%">
                                <Heading fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">Catalog</Heading>
                                <Box w="100%" justifyContent="space-between">
                                    {t('core.datasetBox.legend')}:
                                    <Badge ml={2} colorScheme="blue" variant="solid">General</Badge>
                                    <Badge ml={2} colorScheme="green" variant="solid">Results</Badge>
                                    <Badge ml={2} colorScheme="orange" variant="solid">Processing</Badge>
                                    <Badge ml={2} colorScheme="purple" variant="solid">Staging</Badge>
                                </Box>
                            </Box>             
                            {categories.map(({ id, name, color }) => {
                                const filteredCatalog = catalog.filter(item => Number(item.cataloguetype_id) === id);
                                return (
                                    <CategoryBox
                                    key={id}
                                    id={id}
                                    name={name}
                                    color={color}
                                    items={filteredCatalog}
                                    onSelect={handleDatasetSelect}
                                    selectedDataset={selectedDataset}
                                    searchTerm={searchTerms[id] || ""}
                                    onSearchChange={handleSearchChange}
                                    t={t}
                                    />
                                );
                            })}
                        </Box>
                        {selectedDataset && (
                            <>
                                <Box borderWidth={2} overflowY="auto" borderColor="rgba(23, 141, 161, 1)" borderRadius={5} height={datasetHeight} width={{ base: "100%", md: "20%" }} p={3}>
                                    {/* Sezione Preference direction */}
                                    <Text fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold">{t('core.operationsBox.preferenceDirection')} :</Text>
                                    {columns.map(col => (
                                    <Box key={col.columnName} mb={2}>
                                        {col.index === "0" ? 
                                        (
                                            <Text fontSize='md' color="rgba(11,78,90,255)" fontWeight='semibold'> {t('core.operationsBox.firstColumn')} : {col.columnName}</Text>
                                        ) :
                                        (
                                            <Text textAlign="center" fontWeight="semibold">{col.columnName}</Text>
                                        )}
                                        {col.index !== "0" && (
                                        <Flex mt={2} gap={2} justifyContent="center">
                                            <Button 
                                                w="40%"
                                                size="sm" 
                                                backgroundColor={preferenceDirection[col.columnName] === true ? "rgba(11,78,90,255)" : "gray.300"}
                                                color={preferenceDirection[col.columnName] === true ? "white" : "rgba(11,78,90,255)"}
                                                _hover={{
                                                    bg: "rgba(8, 60, 70, 255)" ,
                                                    color: "white"
                                                }}
                                                onClick={() => handleDirectionChange(col.columnName, true)}
                                                mr={1}
                                            >
                                                <PiArrowFatUpFill />
                                            </Button>
                                            <Button 
                                                w="40%"
                                                size="sm" 
                                                backgroundColor={preferenceDirection[col.columnName] === false ? "rgba(11,78,90,255)" : "gray.300"}
                                                color={preferenceDirection[col.columnName] === false ? "white" : "rgba(11,78,90,255)"}
                                                _hover={{
                                                    bg: "rgba(8, 60, 70, 255)" ,
                                                    color: "white"
                                                }}
                                                onClick={() => handleDirectionChange(col.columnName, false)}
                                            >
                                                <PiArrowFatDownFill />
                                            </Button>
                                        </Flex>
                                        )}
                                    </Box>
                                    ))}
                                </Box>
                                <Box borderWidth={2} overflowY="auto" borderColor="rgba(23, 141, 161, 1)" borderRadius={5} height={datasetHeight} width={{ base: "100%", md: "50%" }} p={3}>
                                    {/* Sezione Alternative */}
                                    <Box>
                                        <Text fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold" mb={2}>{t('core.operationsBox.alternative')} :</Text>
                                        <Input
                                            bg={"white"}
                                            placeholder={t('core.operationsBox.filterAlternatives')}
                                            mb={3}
                                            value={searchAlternative}
                                            onChange={e => setSearchAlternative(e.target.value)}
                                        />
                                        <MultiSelect
                                            options={displayOptions}
                                            value={selectedAlternatives}
                                            onChange={handleChange}
                                            overrideStrings={{
                                                selectSomeItems: t('core.operationsBox.selectAlternatives'),
                                            }}
                                            disableSearch
                                            ClearSelectedIcon={() => null}
                                        />
                                        
                                        <Flex mt={2} gap={4}>
                                            <Button onClick={resetAlternatives}>Reset</Button>
                                            <Button 
                                                disabled={selectedAlternatives.length === 0}                                     
                                                backgroundColor= "rgba(11,78,90,255)"
                                                color= "white"
                                                _hover={{
                                                    bg: "rgba(8, 60, 70, 255)" ,
                                                    color: "white"
                                                }} 
                                                onClick={submitAlternatives}
                                            >{t('core.operationsBox.submit')}</Button>
                                        </Flex>
                                    </Box>
                                    {/* Sezione Express Cards */}
                                    <Box mt={4}>
                                    <Text fontSize="lg" color="rgba(11,78,90,255)" fontWeight="bold" mb={2}>
                                        {t('core.operationsBox.expressCards')}:
                                    </Text>
                                    {expressCards.map((card, index) => {
                                        const eLInvalid =
                                        card.e_L !== "" &&
                                        card.E_U !== "" &&
                                        Number(card.e_L) > Number(card.E_U);
                                        const EUInvalid =
                                        card.e_L !== "" &&
                                        card.E_U !== "" &&
                                        Number(card.E_U) < Number(card.e_L);

                                        return (
                                        <Box key={index} borderWidth={1} borderColor="gray.300" p={2} mb={2}>
                                            <Text textAlign="center" fontWeight="semibold">{card.label}</Text>
                                            <Flex mt={2} gap={10} justifyContent="center">
                                                {/* e_L */}
                                                <Box>
                                                    <Text>e_L:</Text>
                                                    <NumberInput
                                                        bg="white"
                                                        min={0}
                                                        max={card.E_U !== "" ? Number(card.E_U) : undefined}
                                                        clampValueOnBlur={false}
                                                        size="sm"
                                                        value={card.e_L}
                                                        isInvalid={eLInvalid}
                                                        onChange={handleCardChange(index, "e_L")}
                                                        onBlur={() => {
                                                            if (card.e_L === "") {
                                                                updateExpressCard(index, { e_L: "0" });
                                                            }
                                                        }}
                                                    >
                                                    <NumberInputField />
                                                    <NumberInputStepper>
                                                        <NumberIncrementStepper height="10px" fontSize="xs" />
                                                        <NumberDecrementStepper height="10px" fontSize="xs" />
                                                    </NumberInputStepper>
                                                    </NumberInput>
                                                </Box>
                                                {/* E_U */}
                                                <Box>
                                                    <Text>E_U:</Text>
                                                    <NumberInput
                                                        bg="white"
                                                        min={0}
                                                        max={1000000}
                                                        clampValueOnBlur={false}
                                                        size="sm"
                                                        value={card.E_U}
                                                        isInvalid={EUInvalid}
                                                        onChange={handleCardChange(index, "E_U")}
                                                        onBlur={() => {
                                                            if (card.E_U === "") {
                                                                updateExpressCard(index, { E_U: "1000000" });
                                                            }
                                                        }}
                                                    >
                                                    <NumberInputField />
                                                    <NumberInputStepper>
                                                        <NumberIncrementStepper height="10px" fontSize="xs" />
                                                        <NumberDecrementStepper height="10px" fontSize="xs" />
                                                    </NumberInputStepper>
                                                    </NumberInput>
                                                </Box>
                                            </Flex>
                                        </Box>
                                        );
                                    })}
                                    </Box>
                                </Box>
                            </>
                        )}
                    </>
                )}
                {resultApp && (
                    <Box borderColor="rgba(23, 141, 161, 1)" borderRadius={5} borderWidth={2} height={datasetHeight} width="100%">
                        <iframe
                            srcDoc={htmlResult}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                            title="Customized Overall Ranking Engine Results"
                            />
                    </Box>
                )}
            </Flex>
            <Modal isOpen={isOpen} onClose={() => { onClose(); }} closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t('core.modal.confirmationCancellation')}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {t('core.modal.infoConfirmationCancellation')}
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" mr={3} onClick={handleConfirm}>
                        {t('core.modal.yes')}
                        </Button>
                        <Button colorScheme="red" onClick={() => { onClose(); }}>
                        No
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
    
}

export default CustomizedOverallRankingEngine;
